
import * as React from "react";
import { Box, Fab, Grid, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { useEffect, useState } from "react";

import { setbusinessChooseTab, setUserDetail } from "../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import { routePath } from "../constants/routePath";
import LogOutPop from "./logoutPop";
import { set } from "lodash";

export default function SideBar({ handleClose, menuOpen, anchorEl, setHelpOpen, setShareOpen }) {
  const navigate = useNavigate();

  const bussinessMangementMenu = useSelector(
    (state) => state.reducer.bussinessMangementMenu
  );
  const [currentPage, setCurrentPage] = useState(-1);
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    const currentIndex = urlSideBarMenu.findIndex(
      (item) => item.route === currentPath
    );
    if (currentIndex !== -1) {
      setCurrentPage(currentIndex);
    } else {
      setCurrentPage(-1);
    }
  }, [location.pathname]);

  const dispatch = useDispatch();
  const [active, setActive] = useState(0);

  const [open, setOpen] = useState(false);

  const [header1, setHeader1] = useState([]);
  const urlSideBarMenu = useSelector((state) => state.reducer.urlSideBarMenu);
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const customerChategory = useSelector(
    (state) => state.reducer.customerChategory
  );
  const analatics = useSelector((state) => state.reducer.analatics);

  const NameData = {
    Home: 1,
    "Business Management": 1,
    "Customer Management": 1,
  };

  const titleHead1 = (ele) => {
    const indexRoute = headerMenu.findIndex(
      (it) => it.systemFuctionName === ele.systemFuctionName
    );
    if (NameData[ele?.systemFuctionName]) {
      return ele?.systemFuctionName;
    }
    if (headerMenu[indexRoute]?.regionalFunctionName.includes("Counter Sale")) {
      return "Billing";
    }

    return headerMenu[indexRoute]?.regionalFunctionName;
  };
  return (
    // <Grid
    //   container
    //   spacing={0}
    //   sx={{
    //     background: "#3695b6",
    //     overflowY: "auto",
    //     // maxHeight: "calc(100vh - 60px)",
    //     maxHeight: {
    //       xs: "100vh",
    //       // sm: "calc(100vh - 60px)",
    //       // sm:
    //     },
    //     scrollbarWidth: "thin",
    //     msOverflowStyle: "none",
    //     "&::-webkit-scrollbar": {},
    //     "&::-webkit-scrollbar-thumb": {
    //       background: (theme) => theme.palette.secondary.main, // Color of the thumb (scrollbar handle)
    //       borderRadius: "6px",
    //     },
    //     "&::-webkit-scrollbar-thumb:hover": {
    //       background: "#FFC107",
    //     },
    //   }}
    // >
    //   <Grid sx={{ minHeight: "100vh", height: "auto" }} item md={12}>
    //     {urlSideBarMenu?.map((item, index) => {

    //       return (
    //         <Box
    //           key={"siderbar" + index}
    //           bgcolor="primary"
    //           sx={{
    //             padding: item.systemFuctionName === "Sign Out" ? "4px" : "10px",
    //             height:
    //               item.systemFuctionName !== "Sign Out" ? "1.5rem" : "3rem",
    //             borderBottom: "1px solid white",
    //             background: currentPage === index ? "#127093" : "",
    //             display: "flex",
    //             alignItems: "center",
    //             cursor: "pointer",
    //           }}
    //           onClick={async (e) => {
    //             let tt = titleHead1(item);
    //             setActive(index);
    //             console.log("item systemFuctionName ", tt);
    //             if (
    //               tt !== "Business Management" ||
    //               tt !== "Customer Management"
    //             ) {
    //             }
    //             if (tt === "Business Management") {
    //               if (bussinessMangementMenu[0]) {
    //                 navigate(bussinessMangementMenu[0].route);
    //               }

    //               return;
    //             }
    //             if (tt === "Customer Management") {
    //               if (customerChategory[0]) {
    //                 navigate(customerChategory[0].route);
    //               }

    //               return;
    //             }

    //             if (tt == "Dashboard") {
    //               console.log(
    //                 "item systemFuctionName ",
    //                 item.systemFuctionName
    //               );
    //               if (analatics[0]) {
    //                 navigate(analatics[0].route);
    //               }

    //               return;
    //             }

    //             navigate(item?.route);
    //           }}
    //         >
    //           {item.systemFuctionName}
    //         </Box>
    //       );
    //     })}
    //   </Grid>
    //   <LogOutPop open={open} setOpen={setOpen} />
    // </Grid>
    <>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="setting-button"
        // anchorEl={anchorEl}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 75, left: window.innerWidth }}
        open={menuOpen}
        onClose={handleClose}
        // sx={{
        //   width: "250px",
        // }}
        // anchorOrigin={{
        //   vertical: 'bottom',
        //   horizontal: 'left',
        // }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {urlSideBarMenu?.map((item, index) => {
          return (
            <MenuItem
              key={"siderbar" + index}
              sx={{
                padding: "10px 16px",
                cursor: "pointer",
                background: currentPage === index ? "#EAE9FF" : "",
                '&:hover': {
                  backgroundColor: currentPage === index ? "#EAE9FF" : "none",
                },
              }}
              onClick={async (e) => {
                let tt = titleHead1(item);
                setActive(index);
                console.log("item systemFuctionName ", tt);
                if (
                  tt !== "Business Management" ||
                  tt !== "Customer Management"
                ) {
                }
                if (tt === "Business Management") {
                  if (bussinessMangementMenu[0]) {
                    navigate(bussinessMangementMenu[0].route);
                  }
                  return;
                }
                if (tt === "Customer Management") {
                  if (customerChategory[0]) {
                    navigate(customerChategory[0].route);
                  }
                  return;
                }
                if (tt == "Dashboard") {
                  console.log(
                    "item systemFuctionName ",
                    item.systemFuctionName
                  );
                  if (analatics[0]) {
                    navigate(analatics[0].route);
                  }
                  return;
                }
                if(item?.systemFuctionName === "Help and Support") {
                  dispatch(setbusinessChooseTab(null));
                  setHelpOpen(true);
                  handleClose();
                  return;
                }
                 if(item?.systemFuctionName === "Share Elegant Prime App") {
                  dispatch(setbusinessChooseTab(null));
                  setShareOpen(true);
                  handleClose();
                  return;
                }
                navigate(item?.route);
                dispatch(setbusinessChooseTab(null));
                handleClose();
              }}
            >
              {/* Add icon at the start */}
              {item.icon && (
                <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                  {item.icon}
                </Box>
              )}
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {item.systemFuctionName}
              </Typography>
            </MenuItem>
          )
        })}
      </Menu>
      <LogOutPop open={open} setOpen={setOpen} />
    </>
  );
}
